const settings = {
    state: {
        drawer: null,
        isDesktop: null

    },
    mutations: {
        SWITCH_DRAWER(state) {
            state.drawer = !state.drawer
        },
        SET_IS_DESKTOP(state, payload) {
            state.isDesktop = payload
        }
    },
    actions: {
        toggleDrawer: ({
            commit
        }) => {
            commit('SWITCH_DRAWER')
        },
        setIsDesktop({
            commit
        }, value) {
            commit('SET_IS_DESKTOP', value)
        }
    },
    getters: {
        drawer: state => state.drawer,
        isDesktop: state => state.isDesktop
    }
}

export default settings